import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-dark text-white text-center">
      <h1 style={{ fontSize: "6rem", fontWeight: "bold" }}>404</h1>
      <h3 className="mb-3">Oops! Page Not Found</h3>
      <p className="mb-4">The page you’re looking for doesn’t exist or was moved.</p>
      <Link to="/" className="btn btn-light">
        Go to Home
      </Link>
    </div>
  );
};

export default NotFound;
